import {
    aos,
    loginValidation,
    lostPasswordValidation,
    passwordResetValidation,
    accountFormPlaceholder,
    searchBtn,
    mobileMenu,
    availabilityMenu,
    customTooltip,
    cf7Registration,
    loginPopup,
    clearPasswordFields,
    markLessonComplete,
    userMenu,
    select2,
    appointmentPopup,
    offlineLessonSubmit,
    ldStartTest,
    ldTestValidation,
    imageZoom,
    mobileSidebarOverflowHidden,
    productCardTooltip,
    ldTestSortMobile,
    logOutPopup,
    cf7OpinionForm,
    H5pExternalDispatcher,
    injectCssIntoH5P,
    h5pQuestionFeedbackContent,
    ldQuizResult,
    H5pExternalDispatcherPopup,
    capitalizeFirstLetter,
    searchRestrictions,
    logout,
} from './components/index';

const Tbc = {
    init() {
        aos();
        loginValidation();
        lostPasswordValidation();
        passwordResetValidation();
        accountFormPlaceholder();
        searchBtn();
        mobileMenu();
        availabilityMenu();
        customTooltip();
        cf7Registration();
        loginPopup();
        clearPasswordFields();
        markLessonComplete();
        userMenu();
        select2();
        appointmentPopup();
        offlineLessonSubmit();
        ldStartTest();
        ldTestValidation();
        imageZoom();
        mobileSidebarOverflowHidden();
        productCardTooltip();
        ldTestSortMobile();
        logOutPopup();
        cf7OpinionForm();
        H5pExternalDispatcher();
        injectCssIntoH5P();
        h5pQuestionFeedbackContent();
        ldQuizResult();
        H5pExternalDispatcherPopup();
        capitalizeFirstLetter();
        searchRestrictions();
        logout();
    }
};

export default Tbc;

Tbc.init();